import React from 'react';
import {Panel} from 'primereact/panel';
import DataTable from '../../../shared/component/dataTable/DataTable';
import ModelService from "../../../shared/service/ModelService";
import ModelColumn from '../../../shared/component/dataTable/columns/ModelColumn';
import GeneralUtils from "../../../shared/utils/GeneralUtils";
import {Button, Row} from 'reactstrap';
import Translate from "../../../shared/language/Translate";
import ModelSave from "./ModelSave";
import {TabPanel, TabView} from "primereact/tabview";
import {PAGE_MODE} from "../../../shared/utils/Constants";
import Toolbar from "../../../shared/component/toolbar/Toolbar";
import {AvForm} from 'availity-reactstrap-validation';
import AuditEvent from "../../administration/AuditEvent";
import Dialog from "../../../shared/component/dialog/Dialog";


export default class Model extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selected: {},
            pageMode: null
        };
        this.service = new ModelService();
    }

    componentDidMount = () => {
        this.service.checkPage();
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Panel header="Model Yönetimi" style={{width: '50%'}}>
                    <Toolbar display={GeneralUtils.checkPrivilege(ModelColumn.name, 'Create')}>
                        <div className="p-toolbar-group-right">
                            <Button color="primary" onClick={() => {
                                this.setState({displayDialog: true, pageMode: PAGE_MODE.CREATE, activeIndex: 0});
                                this.refModelSave.clearData()
                            }}>
                                <Translate contentKey="entity.action.add">Yeni Kayıt</Translate>
                            </Button>
                        </div>
                    </Toolbar>
                    <DataTable ref={(elem) => this.refDataTable = elem} fields={ModelColumn.fields} dataURL="model/findAll" objectName={ModelColumn.name}
                               selectionMode="single" onDataSelect={this.onDataSelect} action={true}
                               loading={this.state.loading}/>

                    <Dialog visible={this.state.displayDialog}
                            header={GeneralUtils.getDialogHeader('Model', this.state.pageMode)}
                            onHide={() => this.setState({displayDialog: false})} style={{width: '50vw'}}>
                        <AvForm onValidSubmit={this.submit}
                                beforeSubmitValidation={() => this.setState({activeIndex: 0})}>
                            <Toolbar
                                display={GeneralUtils.getDialogToolbarDisplay(ModelColumn.name, this.state.pageMode)}>
                                <div className="p-toolbar-group-right">
                                    <Button color="primary" type="submit" className="float-right">
                                        &nbsp;
                                        <Translate contentKey="entity.action.save">Kaydet</Translate>
                                    </Button>
                                    <Button color="primary" className="float-right"
                                            onClick={() => this.closeDisplayDialog()}>
                                        &nbsp;
                                        <Translate contentKey="entity.action.save">Vazgeç</Translate>
                                    </Button>
                                </div>
                            </Toolbar>
                            <TabView activeIndex={this.state.activeIndex}
                                     onTabChange={(e) => this.setState({activeIndex: e.index})}
                                     renderActiveOnly={false}>
                                <TabPanel header="Model Bilgileri" modal={true}>
                                    <ModelSave save={this.refresh} ref={(elem) => this.refModelSave = elem}
                                               closeDisplayDialog={this.closeDisplayDialog}/>
                                </TabPanel>

                                <TabPanel header="Tarihçe" rightIcon="pi pi-user"
                                          disabled={this.state.pageMode === PAGE_MODE.CREATE}
                                          headerClassName={this.state.pageMode === PAGE_MODE.CREATE && 'displayNone'}>
                                    <AuditEvent ref={elem => this.refAuditEvent = elem} objectName={ModelColumn.name}/>
                                </TabPanel>
                            </TabView>
                        </AvForm>
                    </Dialog>
                </Panel>
            </Row>
        );
    }

    submit = () => {
        this.refModelSave.save();
    }

    refresh = () => {
        this.refDataTable.refresh();
        this.setState({displayDialog: false});
    }


    save = (newData) => {
        if (!GeneralUtils.isNullOrEmpty(newData.id)) {
            this.service.update(newData).then(() => {
                this.refModelSave.setData(PAGE_MODE.UPDATE);
                this.refresh();
            });
        } else {
            this.service.create(newData).then(() => {
                this.refModelSave.setData(PAGE_MODE.CREATE);
                this.refresh();
            });
        }
    }
    onDataSelect = (data) => {
        let pageMode = GeneralUtils.getPageModeFromPrivilege(ModelColumn.name);
        this.setState({
            displayDialog: true,
            pageMode: pageMode,
            activeIndex: 0
        });
        this.refModelSave.setData(Object.assign({}, data), pageMode);
        this.refAuditEvent.setData(ModelColumn.name, data.id);
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }
}
